import { render, staticRenderFns } from "./PartForm.vue?vue&type=template&id=458548f8"
import script from "./PartForm.vue?vue&type=script&lang=js"
export * from "./PartForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports